import AdminNav from 'scoreboard/admin/admin-nav'

/**
 * Creates an instance of the AdminNav view, checks for visible admin items,
 * and returns a promise that resolves with a boolean indicating whether there
 * are visible admin items for the user or not.
 *
 * @returns {Promise<boolean>}
 */
function hasViewableAdminItems() {
	return createDetachedAdminNav().then((adminNav) => {
		// Check for <li> elements with class 'section-item' that are
		// visible (i.e., do not have the class 'is-not-displayed').
		// This also filters out the 'test-pages' item, which is only
		// visible in the development environment.
		const visibleItems = adminNav.$('li.section-item')
			.not('.is-not-displayed').not('.test-pages')

		// Clean up the rendered view
		adminNav.remove()
		adminNav.$el.remove()

		return visibleItems.length > 0
	})
}

/**
 * Creates an instance of the AdminNav in a detached DOM element, renders it,
 * and returns a promise that resolves with the rendered AdminNav instance.
 *
 * @returns {Promise<AdminNav>}
 */
function createDetachedAdminNav() {
	const adminNav = new AdminNav()

	return new Promise((resolve) => {
		adminNav.onceRendered(() => {
			resolve(adminNav)
		})

		// Call the render method to start the rendering process
		adminNav.render()
	})
}

export { hasViewableAdminItems }